import { UseQueryResult } from '@tanstack/react-query'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { Button, Card, CardBody } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { Intervento } from '../../types'
import { getLabelTipoIntervento, useIsCliente } from '../../utils/utils'

interface InterventoPrenotazioneInterface {
  id: Intervento['id']
  tipo_intervento: Intervento['tipo_intervento']
  numero_prenotazione?: Intervento['numero_prenotazione']
  data_richiesta?: Intervento['data_richiesta']
  data_intervento?: Intervento['data_intervento']
  intervento_in_laboratorio?: Intervento['intervento_in_laboratorio']
  stato: Intervento['stato']
  utente_data?: Intervento['utente_data']
  durata_stimata?: Intervento['durata_stimata']
}

type CardPrenotazioneProps = {
  intervento: UseQueryResult<InterventoPrenotazioneInterface, Error>
  modalActionsUpdate?: {
    close: () => void
  }
  updatePartialInterventoJson?: (data: { id: number; intervento_in_laboratorio: boolean }) => Promise<Intervento>
}
export default function CardPrenotazione({
  intervento,
  modalActionsUpdate,
  updatePartialInterventoJson,
}: CardPrenotazioneProps) {
  const isCliente = useIsCliente()
  return (
    <Card>
      <CardBody>
        <div className="d-flex align-items-center justify-content-between">
          <div
            className={classNames('badge', {
              'bg-intervento-periodico-light': intervento?.data?.tipo_intervento === 'verifica_periodica',
              'text-intervento-periodico': intervento?.data?.tipo_intervento === 'verifica_periodica',
              'bg-rapporto-taratura-light': intervento?.data?.tipo_intervento === 'rapporto_taratura',
              'text-rapporto-taratura': intervento?.data?.tipo_intervento === 'rapporto_taratura',
            })}
          >
            {getLabelTipoIntervento(intervento?.data?.tipo_intervento)}
          </div>
          {intervento?.data?.tipo_intervento === 'verifica_periodica' && (
            <div className="p-sm text-body-secondary">Prenotazione n° {intervento?.data?.numero_prenotazione}</div>
          )}
        </div>
        <div className="mt-4 d-flex align-items-center">
          {intervento.data?.data_richiesta && (
            <div>
              <div className="label-m">Data richiesta</div>
              <div className="p-md mt-2 d-flex align-items-center">
                <span
                  className="material-icons me-2"
                  style={{
                    fontSize: '16px',
                  }}
                >
                  calendar_today
                </span>
                {intervento?.data?.data_richiesta ? dayjs(intervento?.data?.data_richiesta).format('DD/MM/YYYY') : ''}
              </div>
            </div>
          )}
          <div
            className={classNames({
              'ms-5': intervento.data?.data_richiesta,
            })}
          >
            <div className="label-m">
              {intervento?.data?.tipo_intervento === 'verifica_periodica' ? 'Data intervento' : 'Data taratura'}
            </div>
            <div className="p-md mt-2 d-flex align-items-center">
              <span
                className="material-icons me-2"
                style={{
                  fontSize: '16px',
                }}
              >
                calendar_today
              </span>
              {intervento?.data?.data_intervento ? dayjs(intervento?.data?.data_intervento).format('DD/MM/YYYY') : ''}
            </div>
          </div>
          {!isCliente && intervento.data?.durata_stimata && (
            <div className="ms-5">
              <div className="label-m">Durata stimata</div>
              <div className="p-md mt-2 d-flex align-items-center">
                <span
                  className="material-icons me-2"
                  style={{
                    fontSize: '16px',
                  }}
                >
                  schedule
                </span>
                {intervento?.data?.durata_stimata}
              </div>
            </div>
          )}
        </div>
        {intervento.data?.utente_data && (
          <div className="mt-4">
            <div className="label-m">Operatore</div>
            <div className="p-md mt-2 d-flex align-items-center">
              <span
                className="material-icons me-2"
                style={{
                  fontSize: '16px',
                }}
              >
                person
              </span>
              {intervento?.data?.utente_data?.full_name}
            </div>
          </div>
        )}
        <div className="mt-4">
          <div className="label-m">Luogo intervento</div>
          <div className="p-md mt-2 d-flex align-items-center">
            {intervento.data?.intervento_in_laboratorio ? 'Laboratorio metrico' : 'Sede cliente'}
            {!isCliente && (intervento?.data?.stato === 'programmato' || intervento?.data?.stato === 'eseguito') && (
              <Button
                size="sm"
                variant="outline-info"
                className="ms-2 py-1 px-2"
                onClick={() => {
                  updatePartialInterventoJson?.({
                    id: Number(intervento.data!.id),
                    intervento_in_laboratorio: !intervento.data?.intervento_in_laboratorio,
                  }).then(() => {
                    toast.success('Intervento modificato con successo', {
                      position: 'bottom-right',
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    })
                    intervento.refetch()
                    modalActionsUpdate?.close()
                  })
                }}
              >
                Cambia
              </Button>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  )
}
